// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__F3tuY","inner":"Footer_inner__1EWuU","nextIcon":"Footer_nextIcon__3bmvC","innerLeft":"Footer_innerLeft__33-4_"};